enum ContactRoles {
  Billing = 'billing',
  Paralegal = 'paralegal',
  Attorney = 'attorney',
  Adjuster = 'adjuster',
  LegalAssistant = 'legal assistant'
}

export default ContactRoles;
